import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { Product, ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { QrProductFeedback } from '../../../store/app.actions';
import { Store } from '@ngxs/store';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NotificationService } from '../../../services/notification.service';
import { LineBreakPipe } from '../../../pipes/line-break.pipe';

@Component({
  selector: 'app-email',
  imports: [CommonModule, ButtonModule, FormsModule, LineBreakPipe],
  templateUrl: './email.component.html',
})
export class EmailComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;
  @Input({ required: true }) product!: Product;

  items: ProductDesignTemplatePageModuleDataContent[] = [];
  tenantId = 'regenesis';
  email = '';

  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);
  private readonly notificationService = inject(NotificationService);

  constructor() {
    this.tenantId = this.route.snapshot.queryParams['x-tenant-id'] || 'regenesis';
  }

  ngOnChanges(_changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }

  subscribeNewsletter() {
    if (this.email === '') {
      return;
    }
    this.store.dispatch(
      new QrProductFeedback({
        type: 'SUBSCRIBE',
        email: this.email,
        total_rate: 0,
        user_rate: 0,
        qrProductItemId: this.product.qrProductItem.id
      }, this.tenantId)
    ).subscribe(() => {
      this.notificationService.openSuccessToast("You have successfully subscribed to our newsletter!")
    })
  }
}
